import {findResourceLink} from './resources';
import {ResourceLink} from '../../types';
import {appContextOptions} from '../appContextOptions';

export function createEndoitExists(appId: string) {
    function endpointExists(key: string, overrideLinks?: ResourceLink[]): boolean {
        const {useAppContext} = appContextOptions.instances.get(appId)!;
        const {testing, pinia} = appContextOptions;
        if (testing) {
            return true;
        }
        const appContext = useAppContext(pinia);
        return !!findResourceLink(key, overrideLinks ?? appContext._links);
    }

    return endpointExists;
}
